import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import {
  Label,
  Input,
  Button,
  Alert,
  Popover,
  PopoverHeader,
  PopoverBody,
  Breadcrumb,
  BreadcrumbItem,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  ModalFooter,
  Table,
} from 'reactstrap'
import Tooltip from '../../../components/UI/TooltipIcon/TooptipIcon'
import ErrorMessage from '../../../components/Message/ErrorMessage/ErrorMessage'
import { deepClone } from '../../../utils/copyObject'
import findIndex from 'lodash/findIndex'
import find from 'lodash/find'
import filter from 'lodash/filter'
import axios from '../../../axios'
import { profilePicValidityCheck, roleOptions } from '../../../utils/constants'
import addIcon from '../../../assets/plus.svg'
import { validateEmail } from '../../../utils/validations'
// import Loading from '../../../hoc/Loading/LoadingWithError';
import Loading from '../../../hoc/Loading/Loading'
import { MdCheck } from 'react-icons/md'

import { BiCheck, BiPlus, BiTrashAlt } from 'react-icons/bi'
import { toastContainer } from '../../../utils/toast'
import { Link } from 'react-router-dom'
import numeral from 'numeral'
// import { loadStripe } from '@stripe/stripe-js'
// import {
//   EmbeddedCheckoutProvider,
//   EmbeddedCheckout,
// } from '@stripe/react-stripe-js'

import {
  getTrivvyPlanDetailsPlanWise,
  isNewPlanUpgradable,
  minPlanLimitCheck,
  RECURRING_PLAN_PRICE_DATA,
} from '../data'
import * as url from '../../../utils/url'
import * as actionCreators from '../../../modules/actions'
import { STRIPE_PUBLIC_KEY } from '../../../utils/constants'
import { isMobile } from '../../../utils/deviceInfo'
import OoPopover from '../../../components/UI/Popover/OoPopover'
import PlanInquiryForm from './PlanInquiryForm'

// const stripePromise = loadStripe(STRIPE_PUBLIC_KEY)

function UpgradePlanModal({ apiPlans, user, orgChangeSuccess, ...props }) {
  const trivvyPlanType =
    user &&
    user.profile &&
    user.profile.organizationId &&
    user.profile.organizationId.trivvyPlanType

  const isO2User =
    user &&
    user.profile &&
    user.profile.organizationId &&
    user.profile.organizationId.userSource == 1

  // const [paymentSuccess, setPaymentSuccess] = useState(false)
  const [getQuoteOpen, setGetQuoteOpen] = useState(false)
  // const [clientSecret, setClientSecret] = useState(null)
  const [plan, setPlan] = useState(null)

  useEffect(() => {
    if (user && user.profile && user.profile.organizationId) {
      axios
        .get(url.findOrgById(user.profile.organizationId._id))
        .then(({ data }) => {
          const payload = data.data
          orgChangeSuccess(payload)
        })
    }
  }, [])

  // stripe logic commented out
  // const handleComplete = (data) => {
  //   return setPaymentSuccess(true)
  // }

  // const runAfterPayment = () => {
  //   setClientSecret(null)

  //   setPaymentSuccess(true)

  //   axios
  //     .post(url.handleStripeRecurringcheckoutForWebsitePlans, {
  //       plan: plan,
  //     })
  //     .then(({ data }) => {
  //       const result = data.data

  //       orgChangeSuccess(result)
  //       toastContainer('Payment done & plan activated!', 'success')

  //       // props.history.push("/change-password");
  //     })
  //     .catch((err) => {
  //       toastContainer('Error while increasing response limit', 'error')
  //     })
  // }

  // useEffect(() => {
  //   if (paymentSuccess) {
  //     runAfterPayment()
  //   }
  // }, [paymentSuccess])

  const purchaseSubscriptionPlan = (plan_type) => {
    if (
      isNewPlanUpgradable(
        trivvyPlanType,
        plan_type,
        user.profile.organizationId
      )
    ) {
      setPlan(plan_type)

      if (plan_type == '001') {
        axios
          .post(url.handleStripeRecurringcheckoutForWebsitePlans, {
            plan: '001',
          })
          .then(({ data }) => {
            const result = data.data

            orgChangeSuccess(result)
            toastContainer('Plan activated!')

            // props.history.push("/change-password");
          })
          .catch((err) => {
            toastContainer('Error while increasing response limit', 'error')
          })
      } else {
        // Stripe logic commented out
        // const price = RECURRING_PLAN_PRICE_DATA.find(
        //   (x) => x.plan === plan_type
        // )

        // if (price) {
        //   axios
        //     .post(url.createStripeRecurringcheckoutForWebsitePlans, {
        //       priceId: price.priceId,
        //     })
        //     .then(({ data }) => {
        //       const clientSecret = data.data.clientSecret
        //       setClientSecret(clientSecret)
        //     })
        //     .catch((err) => {
        //       toastContainer('Error while processing payment', 'error')
        //     })
        // }

        // redirect user to external link when using meeting instead of stripe subscription
        window.open('https://www.ouroffice.io/meet', '_blank')
      }
    } else {
      toastContainer(
        'You can only downgrade at your renewal date. Please contact trivvy@ouroffice.io.',
        'error'
      )
    }
  }

  // const trivvyPlans = ['001', '002', '003', '004']
  const trivvyPlans = ['001', '003', '004']
  const PLAN_DESCRIPTION_MAP = {
    '001': 'For individuals and small teams',
    // '002': 'For teams and smaller organizations',
    '003': 'For small and medium organizations',
    '004': 'For organizations of any size',
  }
  return (
    <div>
      {getQuoteOpen && (
        <PlanInquiryForm
          open={getQuoteOpen}
          onClose={() => {
            setGetQuoteOpen(false)
          }}
          user={user}
        />
      )}
      {/* stripe logic commented out */}
      {/* {clientSecret && !paymentSuccess ? (
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={{ clientSecret, onComplete: handleComplete }}>
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      ) : ( */}
        <div>
          {isMobile ? (
            <div className="trivvy-plan-card-container-mobile mt-3 bwai_mp_plans bwai_is_mobile">
              <Row className="p-0 m-0 pink-border-right">
                {trivvyPlans.map((plan, idx) => {
                  const planData = getTrivvyPlanDetailsPlanWise(plan, apiPlans)

                  return (
                    <Col xs={3} className="px-0" key={idx}>
                      <div className="text-center pink-border-around plan-bg-light-blue">
                        <div className="mobile-price-text">{planData.name}</div>
                        <div className="mb-2">
                          <OoPopover
                            target={`plan_modal_desc_${planData.name}`}
                            placement="bottom"
                            headerText={planData.name}
                            bodyText={planData.description}
                          />
                        </div>
                      </div>
                      <div className="pink-border-no-top text-center price-desc-container">
                        {/* <div className="large-price-text pt-2">
                          {planData.isFree ? 'Free' : planData.price}
                        </div> */}
                        <div className="mt-2 px-1">
                          {/* {!planData.isFree ? (
                            <span className="small-price-text-mobile">
                              {' '}
                              billed annually at ${planData.cost * 12}/yr
                            </span>
                          ) : ( */}
                            <span className="small-price-text-mobile">
                              {PLAN_DESCRIPTION_MAP[plan]}
                            </span>
                          {/* )} */}
                        </div>
                      </div>
                    </Col>
                  )
                })}
              </Row>
              <div className="text-center mobile-price-text pink-border-left pink-border-right plan-bg-light-blue">
                Responses up to
              </div>
              <Row className="p-0 m-0 pink-border-right">
                {trivvyPlans.map((plan, idx) => {
                  const planData = getTrivvyPlanDetailsPlanWise(plan, apiPlans)

                  return (
                    <Col xs={3} className="px-0" key={idx}>
                      <div className="text-center pink-border-around">
                        { plan !== "004" && numeral(planData.responses).format('0,0')}{' '}
                        {planData.unlimitedUserSeats ? 'Tailored to Your Needs' : ''}
                      </div>
                    </Col>
                  )
                })}
              </Row>
              {/* <div className="text-center mobile-price-text pink-border-left pink-border-right">
                Metrics and Analytics
              </div>
              <Row className="p-0 m-0 pink-border-right">
                {trivvyPlans.map((plan, idx) => {
                  const planData = getTrivvyPlanDetailsPlanWise(plan, apiPlans);

                  return (
                    <Col xs={3} className="px-0 " key={idx}>
                      <div
                        style={{ height: "80px" }}
                        className="text-center pt-2 pink-border-around small-price-text-mobile"
                      >
                        {planData.performanceMetrics}
                      </div>
                    </Col>
                  );
                })}
              </Row> */}
              <div className="text-center mobile-price-text pink-border-left pink-border-right plan-bg-light-blue">
                Metrics by Trivvy
              </div>
              <Row className="p-0 m-0 pink-border-right">
                {trivvyPlans.map((plan, idx) => {
                  const planData = getTrivvyPlanDetailsPlanWise(plan, apiPlans)

                  return (
                    <Col xs={3} className="px-0" key={idx}>
                      <div className="text-center pink-border-around">
                        {planData.metricsByTrivvy ? (
                          <BiCheck
                            size={20}
                            className="fonnt-weight-bold"
                            color="#ff4500"
                            fontWeight="bold"
                          />
                        ) : (
                          '-'
                        )}
                      </div>
                    </Col>
                  )
                })}
              </Row>
              <div className="text-center mobile-price-text pink-border-left pink-border-right plan-bg-light-blue">
                Metrics by Question
              </div>
              <Row className="p-0 m-0 pink-border-right">
                {trivvyPlans.map((plan, idx) => {
                  const planData = getTrivvyPlanDetailsPlanWise(plan, apiPlans)

                  return (
                    <Col xs={3} className="px-0" key={idx}>
                      <div className="text-center pink-border-around">
                        {planData.metricsByQuestion ? (
                          <BiCheck
                            size={20}
                            className="fonnt-weight-bold"
                            color="#ff4500"
                          />
                        ) : (
                          '-'
                        )}
                      </div>
                    </Col>
                  )
                })}
              </Row>
              <div className="text-center mobile-price-text pink-border-left pink-border-right plan-bg-light-blue">
                Metrics by Users
              </div>
              <Row className="p-0 m-0 pink-border-right">
                {trivvyPlans.map((plan, idx) => {
                  const planData = getTrivvyPlanDetailsPlanWise(plan, apiPlans)

                  return (
                    <Col xs={3} className="px-0" key={idx}>
                      <div className="text-center pink-border-around">
                        {planData.metricsByUsers ? (
                          <BiCheck
                            size={20}
                            className="fonnt-weight-bold"
                            color="#ff4500"
                          />
                        ) : (
                          '-'
                        )}
                      </div>
                    </Col>
                  )
                })}
              </Row>
              <div className="text-center mobile-price-text pink-border-left pink-border-right plan-bg-light-blue">
                Rewards feature
              </div>
              <Row className="p-0 m-0 pink-border-right">
                {trivvyPlans.map((plan, idx) => {
                  const planData = getTrivvyPlanDetailsPlanWise(plan, apiPlans)

                  return (
                    <Col xs={3} className="px-0" key={idx}>
                      <div className="text-center pink-border-around">
                        {planData.rewardFeature != 'No' ? (
                          <BiCheck
                            size={20}
                            className="fonnt-weight-bold"
                            color="#ff4500"
                          />
                        ) : (
                          '-'
                        )}
                      </div>
                    </Col>
                  )
                })}
              </Row>

              <div className="text-center mobile-price-text pink-border-left pink-border-right plan-bg-light-blue">
                Reminder feature{' '}
                <OoPopover
                  target={'plan_modal_reminder'}
                  placement="top"
                  headerText="Reminder Feature"
                  bodyText={`This feature allows users to set reminds in their calendars to review daily any of the questions they answered incorrectly or answered correctly to improve and solidify their learnings.`}
                />
              </div>
              <Row className="p-0 m-0 pink-border-right">
                {trivvyPlans.map((plan, idx) => {
                  const planData = getTrivvyPlanDetailsPlanWise(plan, apiPlans)

                  return (
                    <Col xs={3} className="px-0" key={idx}>
                      <div className="text-center pink-border-around">
                        {planData.reminderFeature ? (
                          <BiCheck
                            size={20}
                            className="fonnt-weight-bold"
                            color="#ff4500"
                          />
                        ) : (
                          '-'
                        )}
                      </div>
                    </Col>
                  )
                })}
              </Row>
              <Row className="p-0 m-0">
                {trivvyPlans.map((plan, idx) => {
                  const planData = getTrivvyPlanDetailsPlanWise(plan, apiPlans)
                  const isCurrent = plan == trivvyPlanType
                  return (
                    <Col xs={3} className="px-0 " key={idx}>
                      {isCurrent ? (
                        <div className="mt-2 text-center">(Current)</div>
                      ) : (
                        <div
                          style={{ height: '40px' }}
                          className="text-center pt-2">
                          {/* {plan == '004' ? (
                            <a
                              href="https://gotrivvy.com/get-demo"
                              className={
                                'btn trivia-action-button-main fill small-button'
                              }
                              target="_blank">
                              Get Quote
                            </a>
                          ) : ( */}
                            <Button
                              size="sm"
                              onClick={() => purchaseSubscriptionPlan(plan)}
                              className={
                                'trivia-action-button-main fill small-button'
                              }>
                              {plan == '001' ? 'Try Basic' : 'Get Started'}
                            </Button>
                          {/* )} */}
                        </div>
                      )}
                    </Col>
                  )
                })}
              </Row>
            </div>
          ) : (
            <div className="trivvy-plan-card-container-modal bwai_mp_plans">
              <Row>
                {trivvyPlans.map((plan, index) => {
                  const isCurrent = plan == trivvyPlanType
                  return (
                    <Col
                      className={`text-center shadow p-0 m-3 trivvy-plan-card ${
                        isCurrent ? 'active' : 'p-2'
                      }`}>
                      <div
                        className={`p-1 bwai_plan_card_head ${
                          isCurrent ? 'is-current' : ''
                        }`}>
                        <h4>
                          {getTrivvyPlanDetailsPlanWise(plan, apiPlans).name}{' '}
                          {isCurrent ? <span>(current)</span> : ''}{' '}
                        </h4>
                      </div>

                      <div className="mt-1">
                        {/* <span className="large-price-text">
                          {getTrivvyPlanDetailsPlanWise(plan, apiPlans).isFree
                            ? 'Free'
                            : getTrivvyPlanDetailsPlanWise(plan, apiPlans)
                                .price}
                        </span>{' '} */}
                        {/* {!getTrivvyPlanDetailsPlanWise(plan, apiPlans)
                          .isFree ? ( */}
                          <span className="small-price-text">
                            {/* {plan == '004' ? (
                              <span>
                                per month starting plan, quoted based on needs.
                              </span>
                            ) : (
                              <span>
                                per month, billed annually at $
                                {getTrivvyPlanDetailsPlanWise(plan, apiPlans)
                                  .cost * 12}
                              </span>
                            )} */}
                            {PLAN_DESCRIPTION_MAP[plan]}
                          </span>
                        {/* ) : (
                          <span className="small-price-text">
                            For individuals and  small teams
                          </span>
                        )} */}
                      </div>

                      {getTrivvyPlanDetailsPlanWise(plan, apiPlans) ? (
                        <div className="p-1">
                          {/* <b>Your plan details</b> */}
                          <ul className="managePlanDesktopUL">
                            <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                              <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                <MdCheck />
                              </div>
                              <span style={{ textAlign: 'left' }}>
                                {getTrivvyPlanDetailsPlanWise(plan, apiPlans)
                                  .unlimitedUserSeats ? (
                                  'Tailored to Your Needs'
                                ) : (
                                  <>
                                    {plan === "001" ? 'Includes' : plan === "003" ? "Up to" : ""}
                                    {' '}
                                    {getTrivvyPlanDetailsPlanWise(plan, apiPlans).seats}
                                    {' '}
                                    Admin
                                    {' '}
                                    {getTrivvyPlanDetailsPlanWise(plan, apiPlans).seats == 1
                                      ? 'Seat'
                                      : 'Seats'}
                                  </>
                                )}
                              </span>
                            </li>
                            {minPlanLimitCheck(plan, '001') && (
                              <>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Communicate via Surveys, Messaging, Knowledge Checks
                                  </span>
                                </li>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    AI-powered Creation of Surveys and Knowledge Checks
                                  </span>
                                </li>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Standard Survey and Message Templates
                                  </span>
                                </li>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Multiple Sharing Methods (Email, QR Code, Link, Pure SMS Text, WhatsApp)
                                  </span>
                                </li>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Two-Way SMS Text Messaging
                                  </span>
                                </li>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Audience Segmentation By Any User Parameter(s)
                                  </span>
                                </li>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Results by Question and by User
                                  </span>
                                </li>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Easy to Add Users (Bulk Upload, Self-Serve QR Code, Invites)
                                  </span>
                                </li>
                              </>
                            )}
                            <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                              <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                <MdCheck />
                              </div>
                              <span style={{ textAlign: 'left' }}>
                                {getTrivvyPlanDetailsPlanWise(plan, apiPlans)
                                  .unlimitedUserSeats
                                  ? 'Tailored to Your Needs'
                                  : 'Up to'}
                                {' '}
                                {getTrivvyPlanDetailsPlanWise(plan, apiPlans)
                                  .unlimitedUserSeats
                                  ? ''
                                  : (
                                    <>
                                      <strong>
                                        {numeral(
                                          getTrivvyPlanDetailsPlanWise(plan, apiPlans)
                                            .responses
                                        ).format('0,0')}
                                      </strong>
                                      {' '}Responses
                                    </>
                                  )}
                              </span>
                            </li>
                            {/* removed in new design */}
                            {/* <li>
                              <MdCheck />
                              <span>
                                Metrics by{' '}
                                {
                                  getTrivvyPlanDetailsPlanWise('001', apiPlans)
                                    .performanceMetrics
                                }
                              </span>
                            </li> */}
                            {/* remove in new feature */}
                            {/* {getTrivvyPlanDetailsPlanWise(plan, apiPlans)
                              .rewardFeature == 'Yes' ? (
                              <li>
                                <MdCheck />
                                <span>Rewards feature</span>
                              </li>
                            ) : null} */}
                            {/* {getTrivvyPlanDetailsPlanWise(plan, apiPlans)
                              .reminderFeature ? (
                              <li>
                                <MdCheck />
                                <span>


                                  Reminder feature
                                </span>
                              </li>
                            ) : null} */}
                            {/* removed in new feature */}
                            {/*
                            {minPlanLimitCheck(plan, '002') ? (
                              <li>
                                <MdCheck />
                                <span>
                                  {' '}
                                  <strong></strong> Feedback summary by AI
                                </span>
                              </li>
                            ) : (
                              ''
                            )} */}
                            {/* removed in new design */}
                            {/* {minPlanLimitCheck(plan, '001') ? (
                              <li>
                                <MdCheck />
                                <span>
                                  {' '}
                                  <strong></strong> Insights and Actions
                                </span>
                              </li>
                            ) : (
                              ''
                            )} */}
                            {/* removed in new design */}
                            {/* {minPlanLimitCheck(plan, '001') ? (
                              <li>
                                <MdCheck />
                                <span>
                                  {' '}
                                  <strong></strong> Survey Samples
                                </span>
                              </li>
                            ) : (
                              ''
                            )} */}
                            {/* removed in new design */}
                            {/* {['003', '004'].includes(plan) ? (
                              <li>
                                <MdCheck />
                                <span>
                                  {' '}
                                  <strong></strong> Notification options
                                </span>
                              </li>
                            ) : null} */}
                            {/* {['003', '004'].includes(plan) ? (
                              <li>
                                <MdCheck />
                                <span> Learning reinforcement</span>
                              </li>
                            ) : null} */}

                            {['001', '002', '003', '004'].includes(plan) ? (
                              <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                  <MdCheck />
                                </div>
                                <span style={{ textAlign: 'left' }}>
                                  {['001', '002', '003'].includes(plan) ? (
                                    <>
                                      Up to{' '}
                                      <strong>
                                        {numeral(
                                          getTrivvyPlanDetailsPlanWise(plan, apiPlans)
                                            .smsLimit
                                        ).format('0,0')}
                                      </strong>
                                      {' '}SMS Text messages
                                    </>
                                  ) : (
                                    'Tailored to Your Needs'
                                  )}
                                </span>
                              </li>
                            ) : null}
                            {minPlanLimitCheck(plan, '002') && (
                              <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                  <MdCheck />
                                </div>
                                <span style={{ textAlign: 'left' }}>
                                  Buy More Responses or Messages Anytime
                                </span>
                              </li>
                            )}

                            {['003', '004'].includes(plan) && (
                              <>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Anonymity Feature to Boost Engagement
                                  </span>
                                </li>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Real-time Sentiment Analysis, Findings and Next Steps
                                  </span>
                                </li>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Automated Flagging of Messages that Need Attention
                                  </span>
                                </li>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Results Segmentation by Any User Parameter(s)
                                  </span>
                                </li>
                                 <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    One-Click Sharing of Findings and Next Steps
                                  </span>
                                </li>
                                 <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Download and Export Features
                                  </span>
                                </li>
                                 <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Customizable Settings (Smart Alerts & Notifications)
                                  </span>
                                </li>
                                 <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Calendar Reminder for Learning Retention
                                  </span>
                                </li>
                              </>
                            )}
                            {['004'].includes(plan) && (
                              <>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Auto-Create Multiple Knowledge Checks
                                  </span>
                                </li>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Auto-Schedule Trivvys
                                  </span>
                                </li>
                                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Product White Labeling
                                  </span>
                                </li>
                                 <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Multilingual Trivvys
                                  </span>
                                </li>
                                    <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                  <div style={{ flexShrink: 0, marginTop: '2px' }}>
                                    <MdCheck />
                                  </div>
                                  <span style={{ textAlign: 'left' }}>
                                    Integrations / Custom Options
                                  </span>
                                </li>
                              </>
                            )}

                            {/* removed in deign */}
                            {/* <li>
                              <MdCheck />
                              <span>Auto-generate multiple trivvys</span>
                            </li> */}
                            {/* {['003', '004'].includes(plan) ? (
                              <li>
                                <MdCheck />
                                <span>Auto schedule trivvys</span>
                              </li>
                            ) : null} */}
                            {/* {plan == '004' && (
                              <li>
                                <MdCheck />
                                <span> Custom Options</span>
                              </li>
                            )} */}
                          </ul>

                          <div className="mb-0">
                            {!isCurrent && (
                              <div>
                                {/* {plan == '004' ? (
                                  <Button
                                    onClick={() => setGetQuoteOpen(true)}
                                    className={
                                      'btn trivia-action-button-main fill'
                                    }>
                                    Get Quote
                                  </Button>
                                ) : ( */}
                                  <Button
                                    onClick={() =>
                                      purchaseSubscriptionPlan(plan)
                                    }
                                    disabled={isO2User}
                                    className={'trivia-action-button-main fill'}>
                                    GET STARTED
                                  </Button>
                                {/* )} */}
                              </div>
                            )}
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                  )
                })}
              </Row>
            </div>
          )}
        </div>
      {/* )} */}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(UpgradePlanModal, axios))
